module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAAAXNSR0IArs4c6QAAAPpJREFUKBVjZCARzJw505yRkXEGCwuLW1JS0muYdiYYg1haUFDwzP///2/++fNnz5w5c4Rg+hhhDFLo/fv3s9y6dWs1UI8MELukp6d/JMsgkKWrVq1i+/DhwwYgk19AQMCdcfbs2S1Ap0qAJMkAHEA9UUD9+1iAjDdABjMZhsC0dAIDHx7oMMGBpxmB6aIQ6DRRSpwCDJoXoDDyBmInIGc50MAfZBr4nwWYwALev3+/C2gIMBYFAsPCwn6RYxgTUOMXoEZPoIvEgOliBSixkWUQSBMoZTIzM7sDmcq3b99eDDSU5KwD15CSkvIOmBFdgIZpAPOQGcgCUgAAI0JX6pp48YUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/search/bi_arrow.png
// module id = dPKA
// module chunks = 2